// ABOUTME: The five phases' glyphs, keyed by the server's phase keys, in phase order; the phase line draws them.
// ABOUTME: Phase names and pill states come from the progress record, never from here.

// Glyphs and keys only; phase names come from progress.pills (the server owns them).
export const TRUST_PHASES = [
  { key: 'take_a_pause', glyph: '◉' },
  { key: 'read_the_moment', glyph: '◈' },
  { key: 'understand_the_impact', glyph: '◎' },
  { key: 'set_things_right', glyph: '⌒' },
  { key: 'take_the_lesson_forward', glyph: '★' },
] as const;
